// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import EmentorArray from '../shared/EmentorArray';
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import ImageAndTextSlideArray from '../shared/ImageAndTextSlideArray';

const SceneSetter = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Images" instructions="Using the controls below, please add slides for this page." required />
      <Controller
        control={control}
        name="content.core"
        render={({field}) => <ImageAndTextSlideArray inputDir={inputDir} {...{control, errors}} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="2" title="eMentor Notes" instructions="Using the controls below, add any supplemental content to this page" />      
      <Controller
        control={control}
        name="content.eMentor"
        render={({ field }) => <EmentorArray {...{ control, errors }} />}
      />
    </div>
  );
};

export default SceneSetter;